
import Why from "./Why"
import Professional from "./professionals"
import Header from "../header"
import Footer from "../footer"
import aboutbanner from '../../images/aboutbanner.jpg'
function About(){
     return(<>
      <Header/>

      <div className="container-fluid p-0">
        <div className="row m-0">
          <div className="col-12 p-0 cardbanner">
            <img src={aboutbanner} className="w-100 cardbannerimage"
            />
          </div>
        </div>
      </div>
      <Professional/>
       <Why/>
       <Footer/>
     </>)
}
export default About